/** @file       layout/style.css
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *             Style for the layout component
 */

HTML, BODY, DIV#root {
  height: 100%;
  width: 100%;
}

#layout {
  height: 100%;
  display: grid;
  grid-template-columns: 250px 1fr;
}

.content {
  padding: 40px;
  max-width: 1500px;

  /* If the content comes from an `iframe`, let it handle its own styles. The padding, in particular,
   * has to be done inside the iframe, or iframes with alternate background colours (eg due to dialog
   * elements), or large box shadows, etc, will have the content-area's padding colour as a wierd
   * extra big fat border.
   */
  &:has(> iframe) {
    padding: 0;
    max-width: initial;
    height: 100%;
    overflow: hidden;
  }

  & > iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
}

@media only screen and (max-width: 1000px) {
  #layout {
    display: block;
  }

  .content {
    margin: 0;
  }
}

@media only screen and (max-width: 480px) {
  .content {
    padding: 20px;
  }
}
